import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid } from "recharts";
import { EVENT_TYPES, scrapingChartConfig } from "@/lib/scrapingEvents";
import { ThroughputPoint } from "@/services/scrapingStatsApi";

function fmtTime(ts: number): string {
  return new Date(ts * 1000).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}

// Débit de scraping temps réel : aire empilée par event_type, chaque valeur =
// nombre de scrapes sur les 60s glissantes (= scrapes/min). La courbe avance à
// chaque poll, le point le plus à droite = « maintenant ». Une ligne plate à 0
// est rendue volontairement (= rien ne scrape), pas masquée comme le graphe par
// jour : c'est l'info attendue d'un moniteur live.
export function ScrapingThroughputChart({
  points,
  loading,
}: {
  points: ThroughputPoint[];
  loading?: boolean;
}) {
  if (loading && points.length === 0) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Chargement...</div>;
  }
  if (points.length === 0) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Aucune donnée</div>;
  }

  const data = points.map((p) => ({
    time: fmtTime(p.ts),
    invitation: p.invitation,
    message: p.message,
    candidate: p.candidate,
    company: p.company,
    school: p.school,
    search: p.search,
  }));

  return (
    <ChartContainer config={scrapingChartConfig} className="h-[280px] w-full">
      <AreaChart data={data}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="time" tickLine={false} axisLine={false} minTickGap={32} />
        <YAxis tickLine={false} axisLine={false} allowDecimals={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {EVENT_TYPES.map((t) => (
          <Area
            key={t}
            type="monotone"
            dataKey={t}
            stackId="1"
            fill={`var(--color-${t})`}
            stroke={`var(--color-${t})`}
            fillOpacity={0.4}
          />
        ))}
      </AreaChart>
    </ChartContainer>
  );
}
